import { Markdown } from '@wair/markdown'
import { Divider, message } from 'antd'

import userAvatar from '@/assets/images/chat-user.svg'
import cuAvatar from '@/assets/images/cu-avatar.png'
import { SseResponseEventEnum } from '@/constants/agent'
import { assistantState } from '@/store/assistant'
import { citationRegex, toCitationDirective } from '@/utils/formate'
import { useSnapshot } from 'valtio'
import ToolContent from '../ChatItem/ToolContent'
import styles from '../ChatItem/index.module.less'
import { cn } from '@/utils/css'
import { Copy } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { copyToClipboard } from '@/utils/copyToClipboard'
import { useState } from 'react'

const avatarMap = {
  Human: userAvatar,
  AI: cuAvatar,
}
export const ChatRecord = ({ item, avatar, isShare }: any) => {
  const { curSelectAssistant } = useSnapshot(assistantState)
  let hasTools = item?.value?.some((val: any) => val.type === 'tool')
  const [isTextCopied, setIsTextCopied] = useState(false)
  let tools: any = []
  if (hasTools) {
    tools = item?.value.find((val: any) => val.type === 'tool')?.tools
  }
  if (item?.newChat) {
    return (
      <Divider plain={true} className={styles.newChatDivider}>
        全新的开始
      </Divider>
    )
  }
  const handleCopy = async (content: string) => {
    await copyToClipboard(content)
    if (isTextCopied) return
    assistantState.inputText = content
    setIsTextCopied(true)
    message.success('复制成功')
    setTimeout(() => {
      setIsTextCopied(false)
    }, 2000)
  }
  return (
    <div className={styles.chatItemWrap}>
      <div className={styles.chatItem}>
        {/* <div className={styles.chatAvatar}>
          {item.obj === 'AI' ? (
            <img src={avatar || item?.avatar || curSelectAssistant.image} />
          ) : (
            <img src={avatarMap[item?.obj as keyof typeof avatarMap]} />
          )}
        </div> */}

        <div className="flex-1 relative overflow-hidden">
          {item?.obj === 'Human' && (
            <div
              className={cn(
                styles.userContent,
                'items-end group overflow-hidden',
              )}
            >
              <div className="max-w-[80%] rounded-xl px-5 py-3 text-content-first text-sm bg-[#1C1F2308] whitespace-pre-wrap break-all hover:cursor-pointer">
                <div>{item.value[0].text.content}</div>
              </div>
              <Button
                className={`items-center text-sm text-[#1C1F23] gap-1 invisible ${
                  !isShare && 'group-hover:visible'
                }`}
                variant="custom"
                size="xs"
                onClick={() => handleCopy(item.value[0].text.content)}
              >
                <Copy size={14} />
                复制入框
              </Button>
            </div>
          )}
          {item?.obj === 'AI' && (
            <div className={styles.assistantContent}>
              {item?.value?.map((data: any, index: any) => {
                let tool = {}
                let response: any = {}
                let toolObj: any = data.type === 'tool' ? {} : null
                let text: any = data.type === 'text' ? data.text.content : null
                if (toolObj) {
                  response = data?.tools?.[0].response
                    ? JSON.parse(data?.tools?.[0].response)
                    : {}
                  tool = {
                    event: SseResponseEventEnum.toolResponse,
                    toolObj: {
                      response: data?.tools[0].response,
                      toolName: data?.tools[0].toolName,
                    },
                  }
                }
                if (data.type === 'text') {
                  response = tools?.[0]?.response
                    ? JSON.parse(tools?.[0]?.response || '{}')
                    : {}
                  if (citationRegex.test(data.text.content) && hasTools) {
                    const citationText = toCitationDirective(
                      text,
                      response.result || [],
                    )
                    text = `${citationText}`
                  }
                  return <Markdown content={text} key={index} />
                } else {
                  return <ToolContent content={tool} key={index} />
                }
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
export default ChatRecord
